<template>
  <v-select
    :value="value"
    @input="value => emit(value)"
    :label="config.label"
    :items="services"
    item-text="name"
    item-value="code"
    :required="config.required"
    :error="haveErrors()"
    :rules="config.errors"
    dark>
  </v-select>
</template>

<script>
  import input from '@/mixins/input'
  import collection from './collection'
  export default {
    mixins: [input],
    computed: {
      services () {
        return collection(this, 'inputs.services.services')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Services.vue